import { AppCoreModule } from '@opengov/app-core';
import { AnalyticsModule } from '@opengov/app-core/analytics';
import { ComponentLibraryModule } from '@opengov/component-library-classic/module';
import { composeApp } from '@opengov/compose-app';
import { RouterModule } from '@opengov/compose-app-router';
import { LocaleModule } from '@opengov/locale';
import { ogqlModule } from '@opengov/ogql-client';
import { IComposeAppRendererParams } from '@opengov/compose-app/renderApp';
import { CurrentOrLegacyReportingModule } from '../../reporting-legacy-compose/index';
import { ReportModule } from '../index';
import { actionsToTrack } from './actionsToTrack';

export const createStore = (): {
  store: IComposeAppRendererParams<object>['store'];
} => {
  const store = composeApp([
    RouterModule({ routes: {}, readyForRoutes: Promise.resolve() }),
    ReportModule(),
    ComponentLibraryModule,
    AnalyticsModule({ trackableActions: actionsToTrack }),
    LocaleModule,
    CurrentOrLegacyReportingModule,
    AppCoreModule,
    ogqlModule
  ]);
  return { store };
};
